import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  getBasicSettingSummaryCount(params) {
    return axios.get(`${baseUrl}/settings/common/get-basic-settings-summary-count.do`, params);
  },
  getServerSettingSummaryCount(params) {
    return axios.get(`${baseUrl}/settings/server/get-server-settings-summary-count.do`, params);
  },
  getNetworkSettingSummaryCount(params) {
    return axios.get(`${baseUrl}/settings/network/get-network-settings-summary-count.do`, params);
  },
  getDatabaseSettingsSummaryCount(params) {
    return axios.get(`${baseUrl}/settings/database/get-database-settings-summary-count.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/settings/settings-summary.js